import { CategoryChartParamFetchFn } from "../categoryChart";

export const fetchProviderKpiLastRecordedYear: CategoryChartParamFetchFn = async ({
    locationAdminIds,
    categoryChart,
    kpis = [],
    ...rest
}) => {
    return {
        ...rest,
        locationAdminIds,
        categoryChart,
        kpis,
        latestYear: 2021
    };
};
